// src/components/warranties/WarrantyProductCard.jsx
import { Box, Button, Chip, Divider, Paper, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

const WarrantyProductCard = ({
    product,
    theme,
    colors,
    subtleBorder,
    softText,
    fmtBRL,
    onRemove,
    onSelect, // opcional
}) => {
    if (!product) return null;

    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2,
                borderRadius: 2,
                border: subtleBorder,
                bgcolor: "action.hover",
            }}
        >
            <Grid container spacing={2}>
                {/* Foto */}
                <Grid item xs={12} sm={4} md={3}>
                    <Box
                        sx={{
                            width: "100%",
                            aspectRatio: "1 / 1",
                            borderRadius: 2,
                            overflow: "hidden",
                            border: subtleBorder,
                            bgcolor: theme?.palette?.mode === "dark" ? colors?.pink?.[700] : "#f6f6f6",
                        }}
                    >
                        <Box
                            component="img"
                            src={product.imageUrl}
                            alt={product.product_id_produto}
                            sx={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block",
                            }}
                            onError={(e) => {
                                // fallback simples sem quebrar layout
                                e.currentTarget.style.display = "none";
                            }}
                        />

                        {!product.imageUrl && (
                            <Box
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: softText,
                                }}
                            >
                                Sem foto
                            </Box>
                        )}
                    </Box>
                </Grid>

                {/* Infos */}
                <Grid item xs={12} sm={8} md={9} sx={{ display: "flex" }}>
                    <Stack
                        spacing={1}
                        sx={{
                            height: "100%",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                        }}
                    >
                        {/* topo */}
                        <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            justifyContent="space-between"
                            flexWrap="wrap"
                        >
                            <Typography fontWeight={900}>#{product.product_id_produto}</Typography>

                            <Chip
                                label={fmtBRL ? fmtBRL(product.sell_price) : product.sell_price}
                                sx={{
                                    fontWeight: 800,
                                    bgcolor:
                                        theme?.palette?.mode === "dark"
                                            ? colors?.greenAccent?.[700]
                                            : colors?.greenAccent?.[900],
                                    border: `1px solid ${theme?.palette?.mode === "dark"
                                            ? colors?.greenAccent?.[600]
                                            : colors?.greenAccent?.[800]
                                        }`,
                                }}
                            />
                        </Stack>

                        <Typography color={softText}>
                            {String(product.content_type__model || "").toUpperCase()}
                            {product.quantity ? ` • Qtd: ${product.quantity}` : ""}
                            {product.quantity_sold ? ` • Vendidos: ${product.quantity_sold}` : ""}
                        </Typography>

                        {/* chips (cor/tamanho/pks) */}
                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            {!!product.product_id_produto_color && (
                                <Chip variant="outlined" label={`Cor: ${product.product_id_produto_color}`} />
                            )}
                            {product.product_tamanho !== null && product.product_tamanho !== undefined && (
                                <Chip variant="outlined" label={`Tamanho: ${product.product_tamanho}`} />
                            )}
                            {!!product.product_id_produto_pk && (
                                <Chip variant="outlined" label={`Produto PK: ${product.product_id_produto_pk}`} />
                            )}
                            {!!product.pk && <Chip variant="outlined" label={`Item PK: ${product.pk}`} />}
                        </Stack>

                        <Divider sx={{ my: 0.5 }} />

                        {/* kit info */}
                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            <Chip variant="outlined" label={`Kit: #${product.kit__kit_number ?? "-"}`} />
                            <Chip variant="outlined" label={`Pgto kit: ${product.kit__pay_date || "-"}`} />
                            {!!product.kit__seller__nome && (
                                <Chip variant="outlined" label={`Vendedora do kit: ${product.kit__seller__nome}`} />
                            )}
                        </Stack>

                        {/* ações - fixo embaixo à direita */}
                        <Box sx={{ mt: "auto", display: "flex", justifyContent: "flex-end", gap: 1 }}>
                            {typeof onSelect === "function" && (
                                <Button variant="contained" onClick={onSelect}>
                                    selecionar
                                </Button>
                            )}

                            <Button
                                variant="contained"
                                color="warning"
                                onClick={() => (typeof onRemove === "function" ? onRemove() : null)}
                            >
                                remover
                            </Button>
                        </Box>
                    </Stack>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default WarrantyProductCard;
